<template>

    <v-card :color="settings.surveyBoxColor" flat v-if="!formHidden">
        <v-card-text class="pt-8 pb-3">
            <div @click.stop="passwordAreaClicked">

                <password-field v-model="password"
                                :focus="true"
                                :label="subPanelTranslations.survey_password_field_label"
                                :label-confirm="subPanelTranslations.survey_password_confirmation_field_label"
                                :label-security-indicator="subPanelTranslations.survey_password_security_indicator_label"
                                :validation-complexity-error="subPanelTranslations.survey_password_validation_complexity"
                                :validation-required-error="subPanelTranslations.survey_password_validation_required"
                                :validation-mismatch-error="subPanelTranslations.survey_password_validation_mismatch"
                                :disabled="false"
                                :solo="true"
                                :color="settings.actionButtonColor"
                                :background-color="settings.surveyBoxColor"
                                @valid="setValid"
                ></password-field>
            </div>

            <!-- EDIT MODE CREATE PASSWORD BUTTON -->
            <div v-if="editMode">
                <text-editor
                    v-model="actionButtonTextModel"
                    hint="Reset password button text">

                    <div class="ml-8 pt-4 button-space">
                        <ninja-button :settings="settings">
                            {{ subPanelTranslations.create_password_button_text }}
                        </ninja-button>
                    </div>

                </text-editor>
            </div>

            <!-- CREATE PASSWORD BUTTON -->
            <div v-if="showSubmitButton" class="ml-8 pt-4 button-space">

                <ninja-button
                    @click="createPassword"
                    :settings="settings"
                    :loading="saving"
                >
                    {{ subPanelTranslations.create_password_button_text }}
                </ninja-button>
            </div>

            <!-- RECAPTHA -->
            <div v-if="useRecaptcha" class="ml-8">
                <vue-recaptcha v-show="showCaptcha"
                               @verify="captchaVerified"
                               @expired="captchaExpired"
                               :sitekey="recaptchaSiteKey"
                               :loadRecaptchaScript="true"
                               :language="componentData.language_code"
                ></vue-recaptcha>
            </div>

            <!-- TRANSLATIONS DIALOG -->
            <reset-password-translations-dialog v-model="editDialogModel"
                                                :sub-panel-translations="subPanelTranslations"
                                                @change="translationChanged"
            ></reset-password-translations-dialog>

        </v-card-text>

    </v-card>

</template>

<script>

import TextEditor from "@/components/UI/TextEditor.vue";
import PasswordField from "@/components/UI/PasswordField.vue";
import ResetPasswordTranslationsDialog from "@/modules/PanelistResetPassword/components/ResetPasswordTranslationsDialog.vue";
import colorMixin from "@/components/mixins/colorMixin.js";
import VueRecaptcha from 'vue-recaptcha';
import Api from "@/api.js";
import NinjaButton from "@/components/UI/NinjaButton.vue";

export default {

    mixins: [colorMixin],

    components: {
        NinjaButton,
        PasswordField,
        TextEditor,
        ResetPasswordTranslationsDialog,
        VueRecaptcha
    },

    props: {

        editMode: {
            type: Boolean,
            required: false,
            default: false,
        },
        subPanelTranslations: {
            type: Object,
            required: true,
            default: false
        },
        settings: {
            type: Object,
            required: false,
            default: null,
        },
        componentData: {
            type: Object,
            required: false,
            default:() => {
                return {
                    use_recaptcha: false,
                }
            }
        }
    },

    data() {
        return {
            debug: true,
            password: '',
            isValid: false,
            editDialogModel: false,
            formHidden: false,
            captchaToken: null,
            saving: false,
        }
    },

    computed: {

        showCaptcha() {
            if (!this.settings) return false;
            if (this.captchaToken) return false;
            return this.componentData.use_recaptcha && this.isValid;
        },

        useRecaptcha() {
            if (!this.settings) return false;
            return this.componentData.use_recaptcha;
        },

        recaptchaSiteKey() {
            if (!this.settings) return null;
            return this.componentData.recaptcha_site_key;
        },

        showSubmitButton() {
            if (this.settings && this.componentData.use_recaptcha) {
                return this.captchaToken && this.isValid;
            } else {
                return this.isValid;
            }
        },

        actionButtonTextModel: {
            get() {
                return this.subPanelTranslations.create_password_button_text;
            },
            set(value) {
                this.$emit('change:subPanelTranslations', {create_password_button_text: value});
            }
        },
    },

    methods: {

        captchaVerified(captchaToken) {
            this.captchaToken = captchaToken;
        },

        captchaExpired() {
            this.captchaToken = null;
        },

        createPassword() {

            let data = {
                password: this.password
            }

            if (this.componentData.use_recaptcha) {
                data.captchaToken = this.captchaToken;
            }

            this.saving = true;

            let url =  '/landing-page/password-reset-confirmed/' + this.componentData.sub_panel_id + '/' + this.componentData.locale_code;

            if (this.componentData && this.componentData.email) {
                url += '?email=' + encodeURIComponent(this.componentData.email)
            }

            Api.post(window.location.href, data)

                .then(() => {
                    this.sendToUrl(url);
                })
                .catch(() => {

                    this.saving = false;

                    Bus.$emit('flash-message', {
                        type: 'error',
                        message: 'Oops! That failed please try again later!'
                    });
                })
        },

        passwordAreaClicked() {
            if (this.editMode) {
                this.editDialogModel = true;
            }
        },

        translationChanged(object) {
            this.$emit('change:subPanelTranslations', object);
        },

        setValid(value) {
            this.isValid = value;
        }
    },
}
</script>

<style scoped>

.button-space {
    height: 78px;
}

</style>
